type UserProjectVisibilityShape = {
    id: string;
    created_at?: string | null;
    deleted_at?: string | null;
    is_inbox?: boolean | null;
};

function compareProjectCreatedAtDesc<T extends Pick<UserProjectVisibilityShape, 'created_at'>>(
    left: T,
    right: T
) {
    const leftTime = left.created_at ? new Date(left.created_at).getTime() : 0;
    const rightTime = right.created_at ? new Date(right.created_at).getTime() : 0;

    return rightTime - leftTime;
}

export function isVisibleUserProject<T extends Pick<UserProjectVisibilityShape, 'is_inbox' | 'deleted_at'>>(
    project: T | null | undefined
): project is T {
    return project != null && !project.is_inbox && !project.deleted_at;
}

export function filterVisibleUserProjects<T extends UserProjectVisibilityShape>(projects: T[]): T[] {
    return projects
        .filter(isVisibleUserProject)
        .sort(compareProjectCreatedAtDesc);
}

export function upsertVisibleUserProject<T extends UserProjectVisibilityShape>(
    projects: T[],
    project: T
): T[] {
    const withoutCurrent = projects.filter((entry) => entry.id !== project.id);

    if (!isVisibleUserProject(project)) {
        return withoutCurrent;
    }

    return [...withoutCurrent, project].sort(compareProjectCreatedAtDesc);
}
